// extracted by mini-css-extract-plugin
module.exports = {"container":"doughtnut_container__1oa3r","paper":"doughtnut_paper__3xtFI"};